"use client"
import React from "react";
import Link from "next/link"
import { usePathname } from "next/navigation";

export default function NavMainLink({href, children} : {href:string, children:React.ReactNode}) {
  const pathname = usePathname();
  return <Link className={`secondary-nav-item ${pathname.indexOf(href) >= 0 ? "secondary-nav-item--active" : ""}`} href={href}>
    <div className="secondary-nav-item__label">
      <div className="secondary-nav-item__label__content">
        {children}
      </div>
    </div>
  </Link>
}
